enum OrganizationStatusEnum{
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export default OrganizationStatusEnum
